import React from 'react';
import BetaBadge from '../../BetaBadge';
import cn from 'classnames';
import s from './MuroCommentIcon.scss';
const MuroCommentIcon = ({ withNewMarker = true })=>/*#__PURE__*/ React.createElement("div", {
        className: cn(withNewMarker && s['root'])
    }, /*#__PURE__*/ React.createElement("svg", {
        className: cn(withNewMarker && s['muroIcon']),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        height: "28px",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M17.354 9.751c-1.581-.497-2.83-1.699-3.329-3.315a.26.26 0 0 0-.499 0 5.019 5.019 0 0 1-3.329 3.315.259.259 0 0 0 0 .498c1.582.497 2.83 1.698 3.329 3.314a.26.26 0 0 0 .5 0 5.02 5.02 0 0 1 3.328-3.314c.208-.083.208-.415 0-.498ZM10.47 14.585c-1.068-.331-1.911-1.133-2.248-2.21a.177.177 0 0 0-.338 0 3.369 3.369 0 0 1-2.248 2.21.172.172 0 0 0 0 .332c1.068.331 1.911 1.132 2.248 2.21a.177.177 0 0 0 .338 0 3.369 3.369 0 0 1 2.248-2.21c.14-.056.14-.277 0-.332ZM17.747 15.504c.25.126.503.266.754.423.993.62 1.982 1.508 2.697 2.748l4.563-5.1c2.25-2.825-.864-4.8-2.976-2.85l-5.038 4.78ZM20.07 19.87c1.228 3.92-4.09 7.667-10.037 4.517-.317-.167-.294-.62.033-.768.69-.314 1.585-1.048 2.037-2.764.79-3.017 3.168-5.006 5.407-3.932 1.198.575 2.053 1.327 2.56 2.946Z"
    })), withNewMarker && /*#__PURE__*/ React.createElement(BetaBadge, {
        className: s['newIcon'],
        size: "small",
        variant: "purple",
        badgeType: "new"
    }));
MuroCommentIcon.displayName = 'MuroCommentIcon';
export default MuroCommentIcon;

//# sourceMappingURL=MuroCommentIcon.js.map